import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const problems = [{
  title: 'Inflamación Crónica',
  desc: 'Sientes pesadez y dolor articular diario.'
}, {
  title: 'Insomnio y Ansiedad',
  desc: 'El estrés no te deja descansar.'
}, {
  title: 'Problemas Digestivos',
  desc: 'Gases, hinchazón y falta de energía.'
}, {
  title: 'Dependencia Farmacéutica',
  desc: 'Estás cansada de los efectos secundarios.'
}];
export function PainSection() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-paper" data-id="element-91">
      <div className="max-w-xl mx-auto" data-id="element-92">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl sm:text-3xl font-serif font-bold text-center mb-3 sm:mb-4 text-brand-forest leading-tight" data-id="element-93">
          El problema no es tu edad, es que tu botiquín está lleno de parches
          químicos.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-sm sm:text-base text-center text-brand-muted font-medium mb-5 sm:mb-7 leading-relaxed" data-id="element-94">
          Nuestros antepasados vivían más sanos no porque tuvieran suerte, sino
          porque sabían que la naturaleza es el laboratorio más grande del
          mundo. Hoy en día, dependemos de pastillas que alivian un síntoma,
          pero dañan tu hígado, tu estómago y tu bolsillo.
        </motion.p>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-sm sm:text-base font-bold text-brand-forest mb-4 italic" data-id="element-95">
          ¿Sufres de alguno de estos problemas?
        </motion.p>

        <div className="space-y-2.5 sm:space-y-3" data-id="element-96">
          {problems.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex gap-3 items-start bg-white p-4 sm:p-5 rounded-xl border border-brand-border shadow-sm" data-id="element-97">
              <div className="mt-0.5 bg-red-500/10 p-1.5 rounded-full shrink-0" data-id="element-98">
                <XIcon className="w-4 h-4 text-red-600" strokeWidth={3} data-id="element-99" />
              </div>
              <div data-id="element-100">
                <p className="text-sm sm:text-base font-bold text-brand-forest leading-snug" data-id="element-101">
                  {p.title}
                </p>
                <p className="text-xs sm:text-sm text-brand-muted font-medium leading-snug mt-0.5" data-id="element-102">
                  {p.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}